import React from 'react';
import MagazineList from '../features/magazines/MagazineList';

const Magazines = () => {
    return (
        <div>
            <MagazineList />
        </div>
    );
};

export default Magazines;